// import { Tabs } from 'flowbite-react';
import React, { useContext, useEffect, useState } from 'react';
import './BlogPage.css';
import { Link, useLoaderData } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import toast from 'react-hot-toast';
import { AuthProvider } from '../../../Context/AuthContext';
import ScrollToTop from '../../../Shared/ScrollToTop/ScrollToTop';
import { useQuery } from '@tanstack/react-query';
import Example from './CommentTabbar';

const BlogDetails = () => {
    const { user } = useContext(AuthProvider)
    const currTime = new Date().toLocaleTimeString();
    console.log(currTime)
    // const currDate = new Date().toLocaleDateString();
    // console.log(currDate)
    const current = new Date();
    const currDate = `${current.getDate()}/${current.getMonth() + 1}/${current.getFullYear()}`;
    // const [comments, setComments] = useState([])
    const { handleSubmit, register } = useForm()
    const [loading, setLoading] = useState(false)


    const blogData = useLoaderData()

    console.log(blogData)
    const { title, image, role, category, description, desc2, desc3, coute, _id } = blogData


    // getting somments for showing
    const { data: comments = [], refetch } = useQuery({
        queryKey: ['commentsbyid'],
        queryFn: () => fetch(`${process.env.REACT_APP_API_URL}/commentsbyid?commentID=${_id}`)
            .then(res => res.json())
    })



    // getting blog data
    const { data: blogsData = [], isLoading } = useQuery({
        queryKey: ['blog'],
        queryFn: () => fetch(`${process.env.REACT_APP_API_URL}/blogs`)
            .then(res => res.json())
    })

    const onSubmit = event => {
        setLoading(true)
        console.log(event)
        const commentData = {
            name: user?.displayName,
            email: user?.email,
            image: user?.photoURL,
            date: currDate,
            commentID: _id,
            message: event.message,
        }
        console.log(commentData)
        axios.post(`${process.env.REACT_APP_API_URL}/comments`, commentData)
            .then(res => {
                console.log(res.data)
                toast.success("Thank You for Commenting")
                refetch()
                setLoading(false)
            })
            .catch(err => {
                console.log(err)
                setLoading(false)
            })
    }

    // useEffect(() => {
    //     getComments()
    // }, [])

    // const getComments = () => {
    //     axios.get(`${process.env.REACT_APP_API_URL}/commentsbyid?commentID=${_id}`)
    //         .then(data => {
    //             console.log(data)
    //             setComments(data.data)
    //         })
    //         .catch(err => console.log(err))
    // }


    return (
        <div className='max-w-6xl mx-auto px-5 xl:px-0 py-9'>
            <ScrollToTop />
            <div>
                <div className='flex flex-col xl:flex-row items-start gap-11 relative lg:pt-11'>
                    <div className='flex-1'>
                        <div className='relative flex flex-col items-center justify-center'>
                            <img
                                src={image}
                                alt=""
                                className='w-full h-52 md:h-96' />
                            <h3 className='w-32 h-12 font-semibold flex items-center justify-center bg-black text-white absolute top-0 right-0 lg:top-48 lg:-left-9'>25-12-22</h3>
                            <div className=' pt-7 '>
                                <div className='flex-1'>
                                    <div className='lg:pl-16'>
                                        <h3 className='text-xl font-bold '>{title.slice(0, 65)}...</h3>
                                        <div className='flex items-center text-sm gap-4 pt-2 pb-7'>
                                            <p className='border-r-2 pr-5 border-black'><i className=" pr-2 fa-solid fa-user text-regal-orange"></i>{role}</p>
                                            <p> <i className="pr-2  fa-solid fa-comments  text-regal-orange "></i>{category}</p>
                                        </div>
                                        <p className='text-base'>{description}</p>
                                    </div>
                                    <div className='lg:px-11 px-5 py-7 blogDetails-bg my-7'>
                                        <i className="text-4xl fa-solid fa-quote-left"></i>
                                        <h3 className='px-5 lg:px-9 font-semibold italic'>{coute}</h3>
                                        <div className='flex justify-end'>
                                            <i className="text-4xl fa-solid fa-quote-right text-end"></i>
                                        </div>
                                    </div>
                                    <div className='lg:pl-16 my-7'>
                                        <p className='text-base lg:pr-16'>{desc2}</p>

                                        <p className='pt-5 underlined text-semibold lg:pr-16'>{desc3}</p>
                                    </div>
                                    <div className='flex mt-9  py-2'>
                                        <div className='flex items-center justify-between flex-col md:flex-row gap-11'>
                                            <h3 className=''><i class="fa-solid fa-share-nodes text-xl text-regal-orange pr-2"></i> Share This Blog:</h3>
                                            <div className='flex items-center gap-3'>
                                                <div className="px-9 py-2 rounded bg-gray-100 hover:text-regal-orange ">
                                                    <i class="fa-brands fa-facebook-f "></i>
                                                </div>
                                                <div className="px-9 py-2 rounded bg-gray-100 hover:text-regal-orange ">
                                                    <i class="fa-brands fa-twitter "></i>
                                                </div>
                                                <div className="px-9 py-2 rounded bg-gray-100 hover:text-regal-orange ">
                                                    <i class="fa-regular fa-paper-plane "></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* comments tabbar */}

                                    <div>
                                        <Example
                                            handleSubmit={handleSubmit}
                                            register={register}
                                            onSubmit={onSubmit}
                                            comments={comments}
                                            blogData={blogData}
                                            loading={loading}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                    {/* right side section  */}

                    <div className='w-full lg:w-96 -mt-5 lg:-mt-0'>
                        <div className="w-full flex gap-1 items-center flex-col lg:flex-row">
                            <div class="relative w-full">
                                <span class="absolute inset-y-0 left-0 flex items-center pl-3">
                                    <svg class="w-5 h-5 text-gray-400" viewBox="0 0 24 24" fill="none">
                                        <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                    </svg>
                                </span>

                                <input type="text" class="w-full py-3 pl-10 pr-4 text-gray-700 bg-white border rounded-md dark:bg-gray-900 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 dark:focus:border-blue-300 focus:outline-none focus:ring focus:ring-blue-300 focus:ring-opacity-40" placeholder="Search" />
                            </div>
                            <button className='bg-blue-500 text-white w-full hover:bg-blue-600 transition duration-300 ease-in text-sm rounded-md lg:w-24  h-12 uppercase'>Search</button>
                        </div>

                        <div className='mt-7'>
                            <h3 className='text-2xl font-semibold pb-5'> Blog Category</h3>
                            <div>
                                {
                                    blogsData?.slice(0, 5).map(blog =>
                                        <div className='flex items-center justify-between border-b-2 border-gray-300 py-2 group cursor-pointer'>
                                            <h3 className='text-lg font-semibold group-hover:text-blue-500 transition duration-300 ease-in '>{blog.desc2.slice(0, 25)}</h3>
                                            <i class="fa-solid fa-caret-right group-hover:text-blue-500 transition duration-300 ease-in"></i>
                                        </div>
                                    )
                                }
                            </div>
                        </div>

                        <div className='mt-11'>
                            <h3 className='text-2xl font-semibold pb-4'>Recent Blog</h3>
                            <div>
                                {
                                    blogsData?.map(blog =>
                                        <Link to={`/blogdetails/${blog._id}`}> <div className='flex items-start lg:flex-row flex-col
                                         gap-3 border-b-2 border-gray-300 pb-2 mt-7 group'>
                                            <img
                                                className='lg:h-28 lg:w-32 w-full rounded'
                                                src={blog.image} alt="" />
                                            <div>
                                                <h3 className='font-semibold text-regal-orange text-xl group-hover:text-blue-500 transition duration-300 ease-in'>{blog.title.slice(0, 45)}...</h3>
                                                <p className='text-gray-400 pt-2'>{blog.desc3.slice(0, 95)}</p>
                                            </div>
                                        </div></Link>
                                    )
                                }
                            </div>
                        </div>
                        <div className='mt-12 '>
                            <h3 className='text-2xl font-semibold pb-4'>Tags</h3>
                            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                                {
                                    [1, 2, 3, 4, 5, 6].map(i =>
                                        <div className="w-full h-9 flex items-center border-2 border-gray-300 justify-center">
                                            Education
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BlogDetails;